import React, { useContext } from 'react';

import { AppContext } from 'src/components/app-context';
import { Panel, PanelTitle } from '@prisjakt/ui/panel';
import type { BrandProductListingFragment } from 'src/types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { MediumCardHorizontalScroll } from 'src/components/horizontal-scroll/variants/medium-card-horizontal-scroll';
import { ProductGridCard } from 'src/components/product-card-new';

const ProductListing = ({
  products,
  brandName,
}: {
  products: BrandProductListingFragment['products'];
  brandName: string;
}) => {
  const { t } = useContext(AppContext);
  return (
    <Panel>
      <PanelTitle>
        {t('brand', 'popular-products.title', { brand: brandName })}
      </PanelTitle>
      <MediumCardHorizontalScroll negativeMargin>
        {products &&
          products.nodes &&
          products.nodes
            .filter(
              Boolean as unknown as (v: any) => v is Exclude<typeof v, null>
            )
            .map((prod, index) => (
              <ProductGridCard
                key={prod.id}
                id={prod.id}
                link={prod.pathName}
                name={prod.name}
                imageSrc={prod.media.first}
                price={
                  prod.priceSummary.regular || prod.priceSummary.alternative
                }
                rating={
                  prod.aggregatedRating?.score || prod.userReviewSummary.rating
                }
                onClick={() =>
                  trackInternalNavigationClick({
                    scope: InternalNavigationScope.BRAND_PRODUCT_CARD,
                    nextPage: prod.pathName,
                    index,
                  })
                }
              />
            ))}
      </MediumCardHorizontalScroll>
    </Panel>
  );
};

export default ProductListing;
